module.exports = __webpack_public_path__ + "img/furima.35756d87.jpeg";